import { render } from "./checkItem.vue?vue&type=template&id=134e6edf&scoped=true&ts=true"
import script from "./checkItem.vue?vue&type=script&lang=ts"
export * from "./checkItem.vue?vue&type=script&lang=ts"

import "./checkItem.vue?vue&type=style&index=0&id=134e6edf&scoped=true&lang=less"
import "./checkItem.vue?vue&type=style&index=1&id=134e6edf&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134e6edf"]])

export default __exports__